{
  "notification": {
    "success": "Успешно",
    "warning": "Предупреждение",
    "error": "Ошибка"
  }
}
